export const CAN_READ_ALERT = 'CAN_READ_ALERT';
export const CAN_MODIFY_ALERT = 'CAN_MODIFY_ALERT';
export const CAN_ADD_NOTE = 'CAN_ADD_NOTE';
export const CAN_READ_NOTE = 'CAN_READ_NOTE';
export const CAN_MODIFY_PERSON = 'CAN_MODIFY_PERSON';
export const CAN_ADD_PERSON_DOCUMENT = 'CAN_ADD_PERSON_DOCUMENT';
export const CAN_DELETE_PERSON_DOCUMENT = 'CAN_DELETE_PERSON_DOCUMENT';
export const CAN_ADD_SCENARIO = 'CAN_ADD_SCENARIO';
export const CAN_MODIFY_SCENARIO = 'CAN_MODIFY_SCENARIO';
export const CAN_DELETE_SCENARIO = 'CAN_DELETE_SCENARIO';
export const CAN_EXECUTE_SCENARIO_TEST = 'CAN_EXECUTE_SCENARIO_TEST';
export const CAN_READ_RISK = 'CAN_READ_RISK';
export const CAN_ADD_RISK_RULE = 'CAN_ADD_RISK_RULE';
export const CAN_MODIFY_RISK_RULE = 'CAN_MODIFY_RISK_RULE';
export const CAN_DELETE_RISK_RULE = 'CAN_DELETE_RISK_RULE';
export const CAN_ADD_QUERY_TEMPLATE = 'CAN_ADD_QUERY_TEMPLATE';
export const CAN_MODIFY_QUERY_TEMPLATE = 'CAN_MODIFY_QUERY_TEMPLATE';
export const CAN_DELETE_QUERY_TEMPLATE = 'CAN_DELETE_QUERY_TEMPLATE';
export const CAN_READ_USER = 'CAN_READ_USER';
export const CAN_MODIFY_USER = 'CAN_MODIFY_USER';
export const CAN_VIEW_USER_MENU = 'CAN_VIEW_USER_MENU';
export const CAN_DEACTIVATE_ALL_USERS = 'CAN_DEACTIVATE_ALL_USERS';
export const CAN_READ_SANCTION_LISTS = 'CAN_READ_SANCTION_LISTS';
export const CAN_MODIFY_SANCTION_LISTS = 'CAN_MODIFY_SANCTION_LISTS';
export const CAN_EXECUTE_SANCTION_LIST_UPDATE = 'CAN_EXECUTE_SANCTION_LIST_UPDATE';
export const CAN_READ_SANCTION_ALERT = 'CAN_READ_SANCTION_ALERT';
export const CAN_MODIFY_SANCTION_ALERT = 'CAN_MODIFY_SANCTION_ALERT';
export const CAN_READ_SCREENING_CLEARANCE_RULE = 'CAN_READ_SCREENING_CLEARANCE_RULE';
export const CAN_ADD_SCREENING_CLEARANCE_RULE = 'CAN_ADD_SCREENING_CLEARANCE_RULE';
export const CAN_MODIFY_SCREENING_CLEARANCE_RULE = 'CAN_MODIFY_SCREENING_CLEARANCE_RULE';
export const CAN_DELETE_SCREENING_CLEARANCE_RULE = 'CAN_DELETE_SCREENING_CLEARANCE_RULE';
export const CAN_ADD_SCREENING_CLEARANCE_RULES_ANALYSIS = 'CAN_ADD_SCREENING_CLEARANCE_RULES_ANALYSIS';
export const CAN_MODIFY_SCREENING_CLEARANCE_RULES_ANALYSIS = 'CAN_MODIFY_SCREENING_CLEARANCE_RULES_ANALYSIS';
export const CAN_DELETE_SCREENING_CLEARANCE_RULES_ANALYSIS = 'CAN_DELETE_SCREENING_CLEARANCE_RULES_ANALYSIS';
export const CAN_READ_SANCTION_CONFIGURATION = 'CAN_READ_SANCTION_CONFIGURATION';
export const CAN_MODIFY_SANCTION_CONFIGURATION = 'CAN_MODIFY_SANCTION_CONFIGURATION';
export const CAN_READ_PERSON = 'CAN_READ_PERSON';
export const CAN_EXECUTE_SCREENING_SEARCH = 'CAN_EXECUTE_SCREENING_SEARCH';

export const CAN_READ_ALL_ORGANISATIONS = 'CAN_READ_ALL_ORGANISATIONS';
export const CAN_MODIFY_ORGANISATION = 'CAN_MODIFY_ORGANISATION';
export const CAN_ADD_ORGANISATION = 'CAN_ADD_ORGANISATION';
export const CAN_MODIFY_ORGANISATION_FEATURE = 'CAN_MODIFY_ORGANISATION_FEATURE';
export const CAN_DELETE_ORGANISATION_DATA = 'CAN_DELETE_ORGANISATION_DATA';
export const CAN_DEACTIVATE_ORGANISATION = 'CAN_DEACTIVATE_ORGANISATION';
export const CAN_ACTIVATE_ORGANISATION = 'CAN_ACTIVATE_ORGANISATION';

export const CAN_READ_SCHEMA = 'CAN_READ_SCHEMA';
export const CAN_MODIFY_SCHEMA = 'CAN_MODIFY_SCHEMA';
export const CAN_VIEW_SCHEMA_MENU = 'CAN_VIEW_SCHEMA_MENU';
export const CAN_MODIFY_ATTRIBUTE_MAPPING = 'CAN_MODIFY_ATTRIBUTE_MAPPING';
export const CAN_VIEW_ATTRIBUTE_MAPPING_MENU = 'CAN_VIEW_ATTRIBUTE_MAPPING_MENU';
export const CAN_READ_DASHBOARD = 'CAN_READ_DASHBOARD';
export const CAN_MODIFY_DASHBOARD = 'CAN_MODIFY_DASHBOARD';
export const CAN_VIEW_DASHBOARD_MENU = 'CAN_VIEW_DASHBOARD_MENU';
export const CAN_READ_QUICK_STATUS_COMMENT = 'CAN_READ_QUICK_STATUS_COMMENT';
export const CAN_ADD_QUICK_STATUS_COMMENT = 'CAN_ADD_QUICK_STATUS_COMMENT';
export const CAN_READ_TRANSACTION = 'CAN_READ_TRANSACTION';
export const CAN_READ_SCENARIO = 'CAN_READ_SCENARIO';
export const CAN_READ_RISK_RULE = 'CAN_READ_RISK_RULE';
export const CAN_READ_QUERY_TEMPLATE = 'CAN_READ_QUERY_TEMPLATE';
export const CAN_READ_WEBHOOK = 'CAN_READ_WEBHOOK';
export const CAN_READ_OAUTH_CLIENT = 'CAN_READ_OAUTH_CLIENT';
export const CAN_ADD_BATCH = 'CAN_ADD_BATCH';
export const CAN_READ_BATCH = 'CAN_READ_BATCH';
export const CAN_VIEW_SYSTEM_MENU = 'CAN_VIEW_SYSTEM_MENU';
export const CAN_MODIFY_SEARCH_INDEX = 'CAN_MODIFY_SEARCH_INDEX';
export const CAN_TRIGGER_PERSON_SCREENABLE_VALUE_CALCULATION = 'CAN_TRIGGER_PERSON_SCREENABLE_VALUE_CALCULATION';
export const CAN_TRIGGER_ENTITY_GROUP_RECALCULATION = 'CAN_TRIGGER_ENTITY_GROUP_RECALCULATION';
export const CAN_CREATE_SCREENABLE_FIELDS_CONFIGURATION = 'CAN_CREATE_SCREENABLE_FIELDS_CONFIGURATION';
export const CAN_MODIFY_SCREENABLE_FIELDS_CONFIGURATION = 'CAN_MODIFY_SCREENABLE_FIELDS_CONFIGURATION';
export const CAN_READ_SCREENABLE_FIELDS_CONFIGURATION = 'CAN_READ_SCREENABLE_FIELDS_CONFIGURATION';
export const CAN_READ_PERSON_SCREENING_CONTEXT_CONFIGURATION = 'CAN_READ_PERSON_SCREENING_CONTEXT_CONFIGURATION';
export const CAN_MODIFY_PERSON_SCREENING_CONTEXT_CONFIGURATION = 'CAN_MODIFY_PERSON_SCREENING_CONTEXT_CONFIGURATION';
export const CAN_READ_SCREENING_ALERT_FILTER = 'CAN_READ_SCREENING_ALERT_FILTER';
export const CAN_DELETE_SCREENING_ALERT_FILTER = 'CAN_DELETE_SCREENING_ALERT_FILTER';
export const CAN_DELETE_SCREENING_CLEARANCE_RULE_CONTENT = 'CAN_DELETE_SCREENING_CLEARANCE_RULE_CONTENT';
export const CAN_MODIFY_SCREENING_CLEARANCE_RULE_CONTENT = 'CAN_MODIFY_SCREENING_CLEARANCE_RULE_CONTENT';
export const CAN_ADD_SCREENING_CLEARANCE_RULE_CONTENT = 'CAN_ADD_SCREENING_CLEARANCE_RULE_CONTENT';
export const CAN_ADD_FINAL_RISK_OVERRIDE_REASON = 'CAN_ADD_FINAL_RISK_OVERRIDE_REASON';
export const CAN_ADD_FINAL_RISK_OVERRIDE = 'CAN_ADD_FINAL_RISK_OVERRIDE';
export const CAN_DELETE_FINAL_RISK_OVERRIDE = 'CAN_DELETE_FINAL_RISK_OVERRIDE';
export const CAN_READ_BRIDGE_SETTINGS = 'CAN_READ_BRIDGE_SETTINGS';
export const CAN_MODIFY_BRIDGE_SETTINGS = 'CAN_MODIFY_BRIDGE_SETTINGS';
export const CAN_READ_CUSTOM_LIST = 'CAN_READ_CUSTOM_LIST';
export const CAN_MODIFY_CUSTOM_LIST = 'CAN_MODIFY_CUSTOM_LIST';
export const CAN_ADD_CUSTOM_LIST = 'CAN_ADD_CUSTOM_LIST';
export const CAN_ARCHIVE_CUSTOM_LIST = 'CAN_ARCHIVE_CUSTOM_LIST';
export const CAN_READ_CUSTOM_LIST_RECORD = 'CAN_READ_CUSTOM_LIST_RECORD';
export const CAN_ADD_CUSTOM_LIST_RECORD = 'CAN_ADD_CUSTOM_LIST_RECORD';
export const CAN_MODIFY_CUSTOM_LIST_RECORD = 'CAN_MODIFY_CUSTOM_LIST_RECORD';
export const CAN_DELETE_CUSTOM_LIST_RECORD = 'CAN_DELETE_CUSTOM_LIST_RECORD';
export const CAN_ADD_CUSTOM_LIST_SCHEMA_FIELD = 'CAN_ADD_CUSTOM_LIST_SCHEMA_FIELD';
export const CAN_MODIFY_CUSTOM_LIST_SCHEMA_FIELD = 'CAN_MODIFY_CUSTOM_LIST_SCHEMA_FIELD';
export const CAN_MODIFY_SCREENING_STATUSES = 'CAN_MODIFY_SCREENING_STATUSES';
export const CAN_READ_DECISION_RULES = 'CAN_READ_DECISION_RULES';
export const CAN_MODIFY_DECISION_RULES = 'CAN_MODIFY_DECISION_RULES';
export const CAN_ADD_CUSTOM_LIST_SCREENING_FIELD = 'CAN_ADD_CUSTOM_LIST_SCREENING_FIELD';
export const CAN_ADD_CUSTOM_LIST_MONITORING_FIELD = 'CAN_ADD_CUSTOM_LIST_MONITORING_FIELD';
export const CAN_READ_CUSTOM_LIST_SCREENING_FIELD = 'CAN_READ_CUSTOM_LIST_SCREENING_FIELD';
export const CAN_READ_CUSTOM_LIST_MONITORING_FIELD = 'CAN_READ_CUSTOM_LIST_MONITORING_FIELD';
export const CAN_DELETE_CUSTOM_LIST_SCREENING_FIELD = 'CAN_DELETE_CUSTOM_LIST_SCREENING_FIELD';
export const CAN_DELETE_CUSTOM_LIST_MONITORING_FIELD = 'CAN_DELETE_CUSTOM_LIST_MONITORING_FIELD';
export const CAN_MODIFY_ALERT_THROUGH_FILTER = 'CAN_MODIFY_ALERT_THROUGH_FILTER';
export const CAN_MODIFY_SNOOZE_CONFIGURATION = 'CAN_MODIFY_SNOOZE_CONFIGURATION';
export const CAN_READ_ALERT_FILTER = 'CAN_READ_ALERT_FILTER';
export const CAN_BULK_CLOSE_ALERTS = 'CAN_BULK_CLOSE_ALERTS';
export const CAN_BULK_OVERRIDE_RISK = 'CAN_BULK_OVERRIDE_RISK';
export const CAN_READ_ALERT_RFI = 'CAN_READ_ALERT_RFI';
export const CAN_READ_CUSTOM_LIST_SIGNIFICANT_FIELD = 'CAN_READ_CUSTOM_LIST_SIGNIFICANT_FIELD';
export const CAN_MODIFY_CUSTOM_LIST_SIGNIFICANT_FIELD = 'CAN_MODIFY_CUSTOM_LIST_SIGNIFICANT_FIELD';
export const CAN_ADD_DOCUMENT = 'CAN_ADD_DOCUMENT';
export const CAN_DELETE_DOCUMENT = 'CAN_DELETE_DOCUMENT';
export const CAN_READ_DOCUMENT = 'CAN_READ_DOCUMENT';
export const CAN_READ_RATE_LIMIT_CONFIG = 'CAN_READ_RATE_LIMIT_CONFIG';
export const CAN_EDIT_RATE_LIMIT_CONFIG = 'CAN_EDIT_RATE_LIMIT_CONFIG';
export const CAN_READ_ENTITY_GROUP = 'CAN_READ_ENTITY_GROUP';
export const CAN_MODIFY_ENTITY_GROUP = 'CAN_MODIFY_ENTITY_GROUP';
export const CAN_ADD_SCREENING_SELECTOR_GROUP = 'CAN_ADD_SCREENING_SELECTOR_GROUP';
export const CAN_MODIFY_SCREENING_SELECTOR_GROUP = 'CAN_MODIFY_SCREENING_SELECTOR_GROUP';
export const CAN_MODIFY_ENTITY_GROUP_SCREENING_CONFIGURATION = 'CAN_MODIFY_ENTITY_GROUP_SCREENING_CONFIGURATION';
export const CAN_CONFIGURE_PEP_AM_TRANSACTION_SCREENING = 'CAN_CONFIGURE_PEP_AM_TRANSACTION_SCREENING';
export const CAN_READ_SCREENING_TEST = 'CAN_READ_SCREENING_TEST';
export const CAN_CREATE_SCREENING_TEST = 'CAN_CREATE_SCREENING_TEST';
export const CAN_DELETE_SCREENING_TEST = 'CAN_DELETE_SCREENING_TEST';
export const CAN_SCHEDULE_SCREENING_TEST = 'CAN_SCHEDULE_SCREENING_TEST';
export const CAN_CANCEL_SCREENING_TEST = 'CAN_CANCEL_SCREENING_TEST';
export const CAN_TEST_JMESPATH_EXPRESSION = 'CAN_TEST_JMESPATH_EXPRESSION';
export const CAN_TEST_SCREENING_CLEARANCE_RULE = 'CAN_TEST_SCREENING_CLEARANCE_RULE';
export const CAN_USE_ALERT_NOTE_TEMPLATE = 'CAN_USE_ALERT_NOTE_TEMPLATE';
export const CAN_READ_ALERT_NOTE_TEMPLATE = 'CAN_READ_ALERT_NOTE_TEMPLATE';
export const CAN_ADD_ALERT_NOTE_TEMPLATE = 'CAN_ADD_ALERT_NOTE_TEMPLATE';
export const CAN_MODIFY_ALERT_NOTE_TEMPLATE = 'CAN_MODIFY_ALERT_NOTE_TEMPLATE';
export const CAN_DELETE_ALERT_NOTE_TEMPLATE = 'CAN_DELETE_ALERT_NOTE_TEMPLATE';
export const CAN_READ_CASE = 'CAN_READ_CASE';
export const CAN_CREATE_CASE = 'CAN_CREATE_CASE';
export const CAN_MODIFY_CASE = 'CAN_MODIFY_CASE';
export const CAN_ARCHIVE_CASE = 'CAN_ARCHIVE_CASE';
export const CAN_USE_NOTE_DRAFT = 'CAN_USE_NOTE_DRAFT';
export const CAN_USE_ENGINEERING_OPERATIONS = 'CAN_USE_ENGINEERING_OPERATIONS';

export const configurationViewPermissions = [
  CAN_MODIFY_SCREENING_STATUSES,
  CAN_READ_BATCH,
  CAN_READ_DECISION_RULES,
  CAN_VIEW_ATTRIBUTE_MAPPING_MENU,
  CAN_VIEW_SCHEMA_MENU,
  CAN_READ_CUSTOM_LIST,
  CAN_READ_ENTITY_GROUP,
  CAN_READ_QUERY_TEMPLATE,
  CAN_READ_SCENARIO,
  CAN_ADD_FINAL_RISK_OVERRIDE_REASON,
  CAN_READ_RISK_RULE,
];

export const allPermissions = [
  CAN_READ_ALERT,
  CAN_MODIFY_ALERT,
  CAN_ADD_NOTE,
  CAN_READ_NOTE,
  CAN_MODIFY_PERSON,
  CAN_ADD_PERSON_DOCUMENT,
  CAN_DELETE_PERSON_DOCUMENT,
  CAN_ADD_SCENARIO,
  CAN_MODIFY_SCENARIO,
  CAN_DELETE_SCENARIO,
  CAN_EXECUTE_SCENARIO_TEST,
  CAN_READ_RISK,
  CAN_ADD_RISK_RULE,
  CAN_MODIFY_RISK_RULE,
  CAN_DELETE_RISK_RULE,
  CAN_ADD_QUERY_TEMPLATE,
  CAN_MODIFY_QUERY_TEMPLATE,
  CAN_DELETE_QUERY_TEMPLATE,
  CAN_READ_USER,
  CAN_MODIFY_USER,
  CAN_VIEW_USER_MENU,
  CAN_DEACTIVATE_ALL_USERS,
  CAN_READ_SANCTION_LISTS,
  CAN_MODIFY_SANCTION_LISTS,
  CAN_EXECUTE_SANCTION_LIST_UPDATE,
  CAN_READ_SANCTION_ALERT,
  CAN_MODIFY_SANCTION_ALERT,
  CAN_READ_SCREENING_CLEARANCE_RULE,
  CAN_ADD_SCREENING_CLEARANCE_RULE,
  CAN_MODIFY_SCREENING_CLEARANCE_RULE,
  CAN_DELETE_SCREENING_CLEARANCE_RULE,
  CAN_ADD_SCREENING_CLEARANCE_RULES_ANALYSIS,
  CAN_MODIFY_SCREENING_CLEARANCE_RULES_ANALYSIS,
  CAN_DELETE_SCREENING_CLEARANCE_RULES_ANALYSIS,
  CAN_READ_SANCTION_CONFIGURATION,
  CAN_MODIFY_SANCTION_CONFIGURATION,
  CAN_READ_PERSON,
  CAN_EXECUTE_SCREENING_SEARCH,
  CAN_READ_ALL_ORGANISATIONS,
  CAN_MODIFY_ORGANISATION_FEATURE,
  CAN_DELETE_ORGANISATION_DATA,
  CAN_READ_SCHEMA,
  CAN_MODIFY_SCHEMA,
  CAN_VIEW_SCHEMA_MENU,
  CAN_MODIFY_ATTRIBUTE_MAPPING,
  CAN_VIEW_ATTRIBUTE_MAPPING_MENU,
  CAN_READ_DASHBOARD,
  CAN_MODIFY_DASHBOARD,
  CAN_VIEW_DASHBOARD_MENU,
  CAN_READ_QUICK_STATUS_COMMENT,
  CAN_ADD_QUICK_STATUS_COMMENT,
  CAN_READ_TRANSACTION,
  CAN_READ_SCENARIO,
  CAN_READ_RISK_RULE,
  CAN_READ_QUERY_TEMPLATE,
  CAN_READ_WEBHOOK,
  CAN_READ_OAUTH_CLIENT,
  CAN_ADD_BATCH,
  CAN_READ_BATCH,
  CAN_VIEW_SYSTEM_MENU,
  CAN_MODIFY_SEARCH_INDEX,
  CAN_TRIGGER_PERSON_SCREENABLE_VALUE_CALCULATION,
  CAN_TRIGGER_ENTITY_GROUP_RECALCULATION,
  CAN_CREATE_SCREENABLE_FIELDS_CONFIGURATION,
  CAN_MODIFY_SCREENABLE_FIELDS_CONFIGURATION,
  CAN_READ_SCREENABLE_FIELDS_CONFIGURATION,
  CAN_READ_PERSON_SCREENING_CONTEXT_CONFIGURATION,
  CAN_MODIFY_PERSON_SCREENING_CONTEXT_CONFIGURATION,
  CAN_READ_SCREENING_ALERT_FILTER,
  CAN_DELETE_SCREENING_ALERT_FILTER,
  CAN_DELETE_SCREENING_CLEARANCE_RULE_CONTENT,
  CAN_MODIFY_SCREENING_CLEARANCE_RULE_CONTENT,
  CAN_ADD_SCREENING_CLEARANCE_RULE_CONTENT,
  CAN_ADD_FINAL_RISK_OVERRIDE_REASON,
  CAN_ADD_FINAL_RISK_OVERRIDE,
  CAN_DELETE_FINAL_RISK_OVERRIDE,
  CAN_READ_BRIDGE_SETTINGS,
  CAN_MODIFY_BRIDGE_SETTINGS,
  CAN_READ_CUSTOM_LIST,
  CAN_MODIFY_CUSTOM_LIST,
  CAN_ADD_CUSTOM_LIST,
  CAN_ARCHIVE_CUSTOM_LIST,
  CAN_READ_CUSTOM_LIST_RECORD,
  CAN_ADD_CUSTOM_LIST_RECORD,
  CAN_MODIFY_CUSTOM_LIST_RECORD,
  CAN_DELETE_CUSTOM_LIST_RECORD,
  CAN_ADD_CUSTOM_LIST_SCHEMA_FIELD,
  CAN_MODIFY_CUSTOM_LIST_SCHEMA_FIELD,
  CAN_MODIFY_SCREENING_STATUSES,
  CAN_READ_DECISION_RULES,
  CAN_MODIFY_DECISION_RULES,
  CAN_ADD_CUSTOM_LIST_SCREENING_FIELD,
  CAN_ADD_CUSTOM_LIST_MONITORING_FIELD,
  CAN_READ_CUSTOM_LIST_SCREENING_FIELD,
  CAN_READ_CUSTOM_LIST_MONITORING_FIELD,
  CAN_DELETE_CUSTOM_LIST_SCREENING_FIELD,
  CAN_DELETE_CUSTOM_LIST_MONITORING_FIELD,
  CAN_MODIFY_ALERT_THROUGH_FILTER,
  CAN_MODIFY_SNOOZE_CONFIGURATION,
  CAN_READ_ALERT_FILTER,
  CAN_BULK_CLOSE_ALERTS,
  CAN_BULK_OVERRIDE_RISK,
  CAN_READ_ALERT_RFI,
  CAN_READ_CUSTOM_LIST_SIGNIFICANT_FIELD,
  CAN_MODIFY_CUSTOM_LIST_SIGNIFICANT_FIELD,
  CAN_ADD_DOCUMENT,
  CAN_DELETE_DOCUMENT,
  CAN_READ_DOCUMENT,
  CAN_READ_RATE_LIMIT_CONFIG,
  CAN_EDIT_RATE_LIMIT_CONFIG,
  CAN_READ_ENTITY_GROUP,
  CAN_MODIFY_ENTITY_GROUP,
  CAN_ADD_SCREENING_SELECTOR_GROUP,
  CAN_MODIFY_SCREENING_SELECTOR_GROUP,
  CAN_MODIFY_ENTITY_GROUP_SCREENING_CONFIGURATION,
  CAN_CONFIGURE_PEP_AM_TRANSACTION_SCREENING,
  CAN_READ_SCREENING_TEST,
  CAN_CREATE_SCREENING_TEST,
  CAN_DELETE_SCREENING_TEST,
  CAN_SCHEDULE_SCREENING_TEST,
  CAN_CANCEL_SCREENING_TEST,
  CAN_TEST_JMESPATH_EXPRESSION,
  CAN_TEST_SCREENING_CLEARANCE_RULE,
  CAN_READ_ALERT_NOTE_TEMPLATE,
  CAN_ADD_ALERT_NOTE_TEMPLATE,
  CAN_MODIFY_ALERT_NOTE_TEMPLATE,
  CAN_DELETE_ALERT_NOTE_TEMPLATE,
  CAN_READ_CASE,
  CAN_CREATE_CASE,
  CAN_MODIFY_CASE,
  CAN_ARCHIVE_CASE,
  CAN_USE_NOTE_DRAFT,
  CAN_USE_ENGINEERING_OPERATIONS,
];
